

import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

interface OverviewProps {
	signer?: any;
	address?: string;
}

const Overview: React.FC<OverviewProps> = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname.split('/').pop() || 'bear-honey';

	const TABS = [
		{ key: 'bear-honey', label: 'Bear Honey' },
		{ key: 'bee-honey', label: 'Bee Honey' },
		{ key: 'hives', label: 'Hives' },
		{ key: 'honeycombs', label: 'Honeycombs' },
		{ key: 'migrate-bears', label: 'Migrate Bears' },
		{ key: 'vx-claim', label: 'Claim VX' },
	];

	return (
		<div className="max-w-4xl mx-auto mt-8">
			<div className="flex flex-wrap gap-2 border-b border-[#55bac3] mb-6">
				{TABS.map(tab => (
					<button
						key={tab.key}
						className={`px-4 py-2 text-sm transition border-b-2 -mb-px focus:outline-none ${currentPath === tab.key ? 'border-white text-white' : 'border-transparent text-[#c4f6f9] hover:text-white'}`}
						onClick={() => navigate(tab.key)}
					>
						{tab.label}
					</button>
				))}
			</div>
			<div>
				<Outlet />
			</div>
		</div>
	);
};

export default Overview;
